import { render, staticRenderFns } from "./action.vue?vue&type=template&id=fba0920c"
import script from "./action.vue?vue&type=script&lang=ts"
export * from "./action.vue?vue&type=script&lang=ts"
import style0 from "./action.vue?vue&type=style&index=0&id=fba0920c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports